import { ElementNode } from "lexical";

export class TableWrapperNode extends ElementNode {
  static getType(): string {
    return "table-wrapper";
  }

  static clone(node: TableWrapperNode): TableWrapperNode {
    return new TableWrapperNode(node.__key);
  }

  createDOM(): HTMLElement {
    const div = document.createElement("div");
    div.className = "tableScrollableWrapper";
    return div;
  }

  updateDOM(): false {
    return false;
  }
}
